import { render, staticRenderFns } from "./VesselParticularsGeneral.vue?vue&type=template&id=73f21628&"
import script from "./VesselParticularsGeneral.vue?vue&type=script&lang=js&"
export * from "./VesselParticularsGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports